<template>
	<b-modal ref="modal" hide-footer hide-header centered :modal-class="theme">
		<CardForm ref="cardForm" />
		<div class="d-flex align-items-center justify-content-end mt-5">
			<button class="btn btn-secondary mr-3" @click="hide">Cancel</button>
			<button class="btn btn-primary" @click="saveCard">
				<span
					v-if="loading"
					class="spinner-border spinner-border-sm"
					role="status"
					aria-hidden="true"
				></span>
				Save
			</button>
		</div>
		<ErrorDialog ref="errDialog" />
	</b-modal>
</template>

<script>
import CardForm from "./CardForm";
import ErrorDialog from "../shared/ErrorDialog";
import CardService from "../../services/card";
import ThemeService from "../../services/theme";

export default {
	name: "CardAddDialog",
	components: {
		CardForm,
		ErrorDialog,
	},
	data() {
		return {
			loading: false,
		};
	},
	created() {
		this.theme = ThemeService.instance().getTheme() || 'light';
		this.listenForThemeChanges();
	},
	methods: {
		show: function () {
			this.$refs["modal"].show();
		},
		hide: function () {
			this.$refs["modal"].hide();
		},
		saveCard: function () {
			this.loading = true;
			this.$refs.cardForm.getCard().then((result) => {
				if (!result) {
					this.loading = false;
					return;
				}
				let token = result.token;
				let name = result.name;
				let card = {
					token: token.id,
					cardHolderName: name,
				};
				CardService.instance()
					.createCard(card)
					.then(() => {
						this.loading = false;
						this.$emit("cardadded");
						this.hide();
					})
					.catch((err) => {
						this.loading = false;
						this.$refs.errDialog.show(err);
					});
			});
		},
		listenForThemeChanges: function () {
			ThemeService.instance().events.on("themechanged", () => {
				this.theme = ThemeService.instance().getTheme();
			});
		},
	},
};
</script>

<style>
</style>